import {put,takeLatest  } from 'redux-saga/effects';
import NetworkHandler from '../net/NetworkHandler'
import {GET_ALL_FRIENDS,GET_ALL_FRIENDS_GOING_TO_MY_LOCATION} from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateCryodexLinks,updateAllFriendsGoingToMyLocation} from '../containers/Home/actions';
import {updateAllCryodex} from '../containers/Home/actions';


function* getAllFriends(action){
const Network = new NetworkHandler();
  
    try{

      const response = yield Network.requestGetAllCryodexes();
      
      if (!(response instanceof Error)) {
		
          yield put(
              updateAllCryodex(
                response
              )
            );
	    localStorage.setItem("allFriends",JSON.stringify(response));
        } else {
            
          yield put(
            error({
              message: `Unable to get all cryodexes. ${response}`,
            })
          );
        }
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to load all cryodexes, please try again.${errorMsg}`,
            })
        );
    }
	
}

function* getRealFriendsGoingToMyLocationSaga(action){
const Network = new NetworkHandler();
  
    try{

      const response = yield Network.requestGetRealFriendsGoingToMyLocation(action);
	  
      if (!(response instanceof Error)) {
		
          yield put(
              updateAllFriendsGoingToMyLocation(
                response
              )
            );
			
			localStorage.setItem("allRealFriends",JSON.stringify(response));
			
			if(response.length < 1)
			{
				localStorage.removeItem("allRealFriends");
			}
			
        } else {
            
          yield put(
            error({
              message: `Unable to get all real friends. ${response}`,
            })
          );
        }
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to load all real friends, please try again.${errorMsg}`,
            })
        );
    }
	
}
	
export default function* usersSagas(){
	yield takeLatest (GET_ALL_FRIENDS,getAllFriends);
	yield takeLatest (GET_ALL_FRIENDS_GOING_TO_MY_LOCATION,getRealFriendsGoingToMyLocationSaga);

}

